import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    const button = event.currentTarget
    const container = button.closest("[data-clipboard-target='source']")?.parentElement || button.parentElement
    const input = container.querySelector("input[data-clipboard-target='source']")

    if (input) {
      navigator.clipboard.writeText(input.value)

      // Visual feedback
      const originalTitle = button.title
      button.title = "Skopiowano!"
      setTimeout(() => {
        button.title = originalTitle
      }, 1500)
    }
  }
}
